import { atom, useRecoilValue } from 'recoil'

export type HistoryStoreType = {
    displayVerifyDocHistory: boolean
    displayConsiderTypeHistory: boolean
}
export const historyStore = atom<HistoryStoreType>({
    key: 'historyStore',
    default: {
        displayVerifyDocHistory: false,
        displayConsiderTypeHistory: false,
    },
})

const useCommentaryStore = () => {
    const historyState = useRecoilValue(historyStore)
    return {
        ...historyState,
    }
}

export default useCommentaryStore
